export default __webpack_public_path__ + "static/media/pacmant.41156962.svg";